// extracted by mini-css-extract-plugin
export default {"vimeo":"DashboardVideoSection_vimeo__eAkfL","container":"DashboardVideoSection_container__3RQ+5","description":"DashboardVideoSection_description__6JQS8"};